var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "#BDBDBD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.694 39.9486V63.8379C127.694 63.8379 111.92 63.9178 111.841 63.8379V39.9486H88.0623C88.0623 39.9486 88.1415 24.0491 88.0623 23.9692H111.841V0H127.694V23.9692H151.472V39.9486H127.694ZM103.915 71.9075V47.9383H80.136V23.9692H16.7258C8.00693 23.9692 0.873291 31.1599 0.873291 39.9486V135.825C0.873291 144.614 8.00693 151.805 16.7258 151.805H111.841C120.56 151.805 127.694 144.614 127.694 135.825V71.9075H103.915ZM16.7258 135.825L40.5046 103.866L56.3572 127.836L80.136 95.8766L111.841 135.825H16.7258Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadFile);
export default __webpack_public_path__ + "static/media/icon-upload-file.4f36ef634d8b4008927cf387f5aea913.svg";
export { ForwardRef as ReactComponent };